module.exports = __webpack_public_path__ + "static/media/landing-page_top.0bd961ec.jpg";